import {
  TrackingDataFieldTypeAccountType,
  TrackingDataFieldTypeLoginMethod,
} from '@shopee-user/tracking-login';
import { TrackingDataFieldTypeSignupMethod } from '@shopee-user/tracking-signup';
import { sha256 } from '../utils/crypto';

export const hashUserId = (userId: number) =>
  sha256(userId.toString()).toString();

const LOGIN_TRACKING_CONTEXT_KEY = '@shopee-user/tob/login_tracking_context';

export type LoginSignupTrackingContext = {
  signupMethod?: TrackingDataFieldTypeSignupMethod;
  loginMethod?: TrackingDataFieldTypeLoginMethod;
  accountType?: TrackingDataFieldTypeAccountType;
  userId?: number;
};

export const saveLoginSignupTrackingContextToLocal = ({
  signupMethod,
  loginMethod,
  accountType,
  userId,
}: LoginSignupTrackingContext) => {
  sessionStorage.setItem(
    LOGIN_TRACKING_CONTEXT_KEY,
    JSON.stringify({ signupMethod, loginMethod, accountType, userId })
  );
};

export const getLoginSignupTrackingContextFromLocal = ({
  autoClear = false,
}: { autoClear?: boolean } = {}) => {
  const context = sessionStorage.getItem(LOGIN_TRACKING_CONTEXT_KEY);
  if (autoClear) {
    clearLoginSignupTrackingContextFromLocal();
  }
  try {
    return context ? (JSON.parse(context) as LoginSignupTrackingContext) : null;
  } catch {
    clearLoginSignupTrackingContextFromLocal();
    return null;
  }
};

export const clearLoginSignupTrackingContextFromLocal = () => {
  sessionStorage.removeItem(LOGIN_TRACKING_CONTEXT_KEY);
};
